import React, { Component } from "react";
import "./Alternative.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Popconfirm, Table, Empty, Spin, Alert,
    Modal, Button, Form, Input, Popover, Typography,
    Steps, Row, Col, Badge, Icon, Tooltip, Upload
} from 'antd';
import { Link } from "react-router-dom";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const { Text } = Typography;


//create alternative modal
const CreateForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const { TextArea } = Input;

            const {
                visible, onCancel, onCreate, form
            } = this.props; //read all the property send from Alternative

            const { getFieldDecorator } = form; //can get the input value
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Create a new alternative"
                    okText="Create"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Alert message="Kindly refrain from including periods (.) in the name field." type="info" showIcon />

                    <Form layout="vertical">
                        <Form.Item label="Alternative name">
                            {getFieldDecorator('alternativeName', {
                                rules: [
                                    { required: true, message: 'Please input the name of alternative!' }
                                ], //set the rule
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Alternative description">
                            {getFieldDecorator('alternativeDescription')(
                                <TextArea placeholder="Alternative description" autoSize />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);


//edit alternative modal
let EditForm = Form.create({ name: 'edit_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {

            const { TextArea } = Input;

            const {
                visible, onCancel, onCreate, form, eAlternative, //get all the props from Alternaive
            } = this.props;

            const { getFieldDecorator } = form;
            return (
                <Modal
                    visible={visible}
                    title={"Edit Alternative " + eAlternative.alternativeName} //the name is different per modal
                    okText="Edit"
                    onCancel={onCancel}
                    onOk={onCreate}
                >

                    <Alert message="Kindly refrain from including periods (.) in the name field." type="info" showIcon />

                    <Form layout="vertical">
                        <Form.Item label="Alternative name">
                            {getFieldDecorator('alternativeName', {
                                rules: [{ required: true, message: 'Please input the name of alternative!' }],
                                initialValue: eAlternative.alternativeName //get the oringinal alternative name
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Alternative description">
                            {getFieldDecorator('alternativeDescription', {
                                initialValue: eAlternative.alternativeDescription //get the oringinal alternative description
                            })(
                                <TextArea autoSize />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);

export default class Alternative extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: Cookie.get("email"),
            projectAlternatives: [],
            createVisible: false, //for create modal
            editVisible: false, //for edit modal,
            loading: true, //the loading status default true
            eAlternative: {}, //for edited alternative
            projectName: "",
            projectType: "",
            licenseType: "Free",
        };

    }

    onStepChange = current => {
        if (this.state.projectType === "MCA") {
            if (current === 1) {
                this.props.history.push(`/mcacriteria/${this.props.match.params.projectid}`)
            }
            if (current === 2) {
                this.props.history.push(`/mcaweight/${this.props.match.params.projectid}`)
            }
            if (current === 3) {
                this.props.history.push(`/mcaevaluation/${this.props.match.params.projectid}`)
            }
            if (current === 4) {
                this.props.history.push(`/mcaresult/${this.props.match.params.projectid}`)
            }
        }
        else {
            if (current === 1) {
                this.props.history.push(`/mamcaactors/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
            }
            if (current === 2) {
                this.props.history.push(`/mamcacriteria/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
            }
            if (current === 3) {
                this.props.history.push(`/mamcaweight/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
            }
            if (current === 4) {
                this.props.history.push(`/mamcaevaluation/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
            }
            if (current === 5) {
                this.props.history.push(`/mamcaresult/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
            }
        }
    };

    //show or cancel create modal
    showCreateModal = () => {
        this.setState({ createVisible: true });
    }

    handleCreateCancel = () => {
        this.setState({ createVisible: false });
    }

    //show or cancel edit modal
    showEditModal = () => {
        this.setState({ editVisible: true });
    }

    handleEditCancel = () => {
        this.setState({ editVisible: false });
    }

    //create alternative
    handleCreate = () => {
        const form = this.formRef.props.form; //get all the data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err || values.alternativeName.trim().length === 0) { //trim the project name to check the length
                return;
            }
            else {
                let alternativeDescription; //if there is description, trim it
                if (values.alternativeDescription != null) {
                    alternativeDescription = values.alternativeDescription.trim()
                }
                fetch('/project/createAlternative', { //REST create alternative
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        alternativeName: values.alternativeName.trim(),
                        alternativeDescription: alternativeDescription
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectAlternatives();
                            message.success(json.message); //create successfully, show message
                            this.setState({ createVisible: false }); //make modal invisible
                            form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });

            }
        });
    }

    //edit alterntive
    handleEdit = () => {
        const form = this.EformRef.props.form; //get data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err || values.alternativeName.trim().length === 0) {
                return;
            }
            else {
                let alternativeDescription;
                if (values.alternativeDescription != null) { //if there is description, trim it
                    alternativeDescription = values.alternativeDescription.trim()
                }
                fetch('/project/editAlternative', { //REST create project
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        aid: this.EformRef.props.eAlternative._id, //get the id of alternative
                        alternativeName: values.alternativeName.trim(),
                        originalAlternativeName: this.EformRef.props.eAlternative.alternativeName, // get original alternative name
                        alternativeDescription: alternativeDescription
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectAlternatives();
                            message.success(json.message); //create successfully, show message
                            this.setState({ editVisible: false }); //make modal invisible
                            form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });
            }
        });
    }
    // Function to download table data as Excel (using this.state.projectAlternatives)
    downloadTemplate = () => {
        const { projectAlternatives } = this.state; // Extract the project alternatives data

        // Prepare data for export (remove "_id" and include only necessary fields)
        let data = projectAlternatives.map(({ alternativeName, alternativeDescription }) => ({
            alternativeName,
            alternativeDescription
        }));

        // Define headers for the Excel sheet
        let headers = [
            { header: 'Alternative Name', key: 'alternativeName' },
            { header: 'Alternative Description', key: 'alternativeDescription' },
        ];

        // File settings
        let fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let fileExtension = '.xlsx';

        // Convert JSON to worksheet
        let ws = XLSX.utils.json_to_sheet(data);
        // Add headers to worksheet
        let ws_with_headers = XLSX.utils.sheet_add_aoa(ws, [headers.map(h => h.header)], { origin: 'A1' });

        // Create workbook and add the worksheet
        let wb = { Sheets: { data: ws_with_headers }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        // Create blob and trigger download
        let dataBlob = new Blob([excelBuffer], { type: fileType });
        saveAs(dataBlob, `Alternative_data${fileExtension}`);
    }


    // //upload excel
    // uploadExcel = (file) => {
    //     const reader = new FileReader();
    //     let data = {}
    //     reader.onload = (evt) => {
    //         const bstr = evt.target.result;
    //         const workbook = XLSX.read(bstr, { type: 'binary' });

    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];

    //         data = XLSX.utils.sheet_to_json(worksheet);
    //         console.log(data)
    //     };

    //     reader.readAsBinaryString(file);
    //     console.log(reader)
    //     if(data){ //if there is data

    //     }
    //     // Prevent default upload behavior
    //     return false;
    // }


    //upload excel
    uploadExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            let data = XLSX.utils.sheet_to_json(worksheet); // Parse worksheet

            if (data && data.length > 0) { //if there is data
                // Confirm upload with user
                if (window.confirm("Do you want to upload the alternatives? You will lose all evaluation results after uploading.")) {
                    fetch('/project/createAlternatives', { //REST create project
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            uid: this.props.match.params.projectid,
                            alternatives: data,
                        }),
                    })
                        .then(res => res.json())
                        .then(json => {
                            console.log("Response from server:", json); // Inspect the server response
                            if (json.success) {
                                message.success("Alternatives uploaded successfully!");
                                window.location.reload(); // Reload to reflect changes
                            } else {
                                message.error(json.message || "Upload failed"); // Handle failure case
                            }
                        })
                        .catch(error => {
                            console.error("Upload error:", error); // Log any errors
                            message.error("Upload failed. Please try again.");
                        });
                }
            } else {
                message.error("No data found in the Excel file.");
            }
        };

        reader.onerror = (error) => {
            console.error("File reading error:", error);
            message.error("Failed to read the file.");
        };

        reader.readAsBinaryString(file);

        // Return false to prevent default upload behavior
        return false;
    };

    //get the alternatives
    getProjectAlternatives = () => {
        fetch(`/project/getProjectAlternatives/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({
                        projectAlternatives: json.projectAlternatives,
                        projectName: json.projectName,
                        projectType: json.projectType,
                        loading: false
                    }) //save project data
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }

    getUserInformation = () => {
        fetch(`/login/getUserInformation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: Cookie.get("email"),
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({ //set state
                        licenseType: json.user.licenseinfo.licenseType, //licensetype
                        expire: json.expire,
                        // soon: json.soon
                    });
                }
            });
    }

    deleteAlternative(aid) { //delete alternative
        fetch('/project/deleteAlternative', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                aid: aid
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProjectAlternatives(); //if success, refresh the alternative list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });
    }

    //save all the form data of create
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }
    //save all the form data of edit
    saveEFormRef = (formRef) => {
        this.EformRef = formRef;
    }

    checkDisable() {
        if (this.state.projectAlternatives.length < 2) {
            return true
        }
        else {
            return false
        }
    }

    componentDidMount() {
        try {
            this.getProjectAlternatives() //after render immediately get alternative list
            this.getUserInformation()
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mcaSteps = [{
            title: 'Alternatives',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        const mamcaSteps = [{
            title: 'Alternatives',
        },
        {
            title: 'Actors',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        const columns = [{ //the column title of the table
            title: 'Alternative Name', //the title of column
            dataIndex: 'alternativeName', //the data index can be used for searching, filtering
            key: 'alternativeName',
            render: (text, record) => <Popover content={record.alternativeDescription} title="Description"><div style={{ cursor: "pointer" }}>{text}</div></Popover>, //make it clickable to the project
            width: '80%',
        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text, record) => (
                <span>
                    {/* save the edited alternative data, which will be used later in edit modal, and then show the edit modal */}
                    <Link to="#" onClick={() => { this.setState({ eAlternative: record }); this.showEditModal(); }}>Edit</Link>
                    <Divider type="vertical" />
                    {/* after comfirmation we can delete the alternative */}
                    <Popconfirm title="Are you sure you want to delete this alternative?" onConfirm={() => { this.deleteAlternative(record._id) }} okText="Yes" cancelText="No">
                        <Link to="#">Delete</Link>
                    </Popconfirm>

                </span>
            ),
        }];

        return <div className="Alternative">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                        <h3>{this.state.projectName}</h3>
                    {/* <Col span={6}>
                        <h4>Project type: {this.state.projectType}</h4>
                    </Col> */}
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} onChange={this.onStepChange} current={0}>
                    {this.state.projectType === "MCA" ? mcaSteps.map(item => <Step key={item.title} title={item.title} />) : mamcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                {this.state.licenseType === "Trial" && this.state.projectAlternatives.length > 2 ?
                    <span>
                        <Button style={{ marginLeft: "0" }} type="primary" size="large" disabled><b>{"\uFF0B\n"}</b> Create a new alternative</Button>
                        <Tooltip title="Trial license can only create 3 alternatives">
                            <Badge dot>
                                <Icon style={{ marginLeft: 10 }} type="warning" />
                            </Badge>
                        </Tooltip>
                    </span>

                    :
                    <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showCreateModal}><b>{"\uFF0B\n"}</b> Create a new alternative</Button>}
                <Divider />
                <Text>Or use excel to upload data:&nbsp;</Text>
                <Button style={{ marginLeft: "0" }} onClick={this.downloadTemplate} > Download data in Excel</Button>

                <Upload accept=".xlsx,.xls" customRequest={({ file }) => this.uploadExcel(file)}>
                    <Button style={{ marginLeft: 8 }} type="primary" > Upload your data in Excel format</Button>
                </Upload>
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.projectAlternatives} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                {this.state.projectAlternatives.length < 2 ? <p>You have to create at least two alternatives to continue</p> : <div />}
                <div className="steps-action">
                    {this.state.projectType === "MCA" ?
                        //disabled={this.checkDisable(this.state.project)}
                        <Button size="large" type="primary" >
                            <Link to={`/mcacriteria/${this.props.match.params.projectid}`}>Next</Link></Button>
                        :
                        // disabled={this.checkDisable(this.state.project)}
                        <Button size="large" type="primary" >
                            <Link to={`/mamcaactors/${this.props.match.params.projectid}`}>Next</Link></Button>
                    }
                </div>
            </Spin>
            <CreateForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.createVisible}
                onCancel={this.handleCreateCancel}
                onCreate={this.handleCreate}
            />
            <EditForm
                wrappedComponentRef={this.saveEFormRef}
                visible={this.state.editVisible}
                onCancel={this.handleEditCancel}
                onCreate={this.handleEdit}
                eAlternative={this.state.eAlternative} //send the edited alternative info to the modal
            />
        </div>;
    }
}